import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ConsumerAuthenticationInformationSetup} from '@app/model/cyber-source/payer-auth-setup-response';

@Component({
  selector: 'dcp-cyber-source-device-data-collection-form',
  templateUrl: './cyber-source-device-data-collection-form.component.html',
  styleUrl: './cyber-source-device-data-collection-form.component.scss'
})
export class CyberSourceDeviceDataCollectionFormComponent {

  @ViewChild('deviceDataCollectionForm') deviceDataCollectionForm?: ElementRef;
  @Input() deviceDataCollectionSetup: ConsumerAuthenticationInformationSetup;

  submit() {
    // Set a delay, because the input value is not available at time and the request failing with error 500
    setTimeout(() => {
      // Your code to execute after the delay
      if (this.deviceDataCollectionSetup?.accessToken) {
        // Submitting the Device Data Collection Iframe. Response event handled by deviceDataCollectionHandler
        this.deviceDataCollectionForm.nativeElement.submit();
      }
    }, 500);
  }
}
